<script setup lang="ts">
const route = useRoute()

// Inject JSON-LD structured data into <head> via a composable (no rendered DOM
// node). Previously <SeoStructuredData /> had an empty template, which renders a
// comment on the client but nothing during prerender — shifting the app-root
// children by one and causing a hydration mismatch on every page.
useSeoStructuredData()
</script>

<template>
  <div class="min-h-screen bg-gray-50 dark:bg-dark-500 overflow-clip">
    <NuxtRouteAnnouncer />
    <AppHeader v-if="route.path !== '/inventorai'" />
    <NuxtPage />
    <TheFooter v-if="route.path !== '/inventorai'" />
  </div>
</template>
